/**
 * Veri yaşam döngüsünün kabukta kullanılan kısa metinleri ve adresleri (M6 WP 6.4). Menü, giriş sayfası ve kayıt komutları bu
 * küçük modülü kullanır; ekranların metinleri (`lifecycle-strings.ts`) ilk pakete girmez.
 */
export const lifecycleNav = {
  lifecycle: 'Veri yaşam döngüsü',
  audit: 'Denetim kayıtları',
  support: 'Destek erişimi',
  /** Kişi/aday kaydının komut menüsü */
  subjectCommand: 'Kişisel veri işlemleri',
  /** Giriş sayfası */
  cancelClosureLink: 'Hesap kapatmayı iptal et',
} as const;

export const LIFECYCLE_ROUTES = {
  lifecycle: '/settings/data-lifecycle',
  audit: '/settings/audit',
  support: '/settings/support-access',
  cancelClosure: '/closure-cancel',
} as const;

/** Kişi/aday için kişisel veri işlemleri sayfası */
export function subjectDataHref(type: 'contact' | 'lead', id: string): string {
  return `${LIFECYCLE_ROUTES.lifecycle}/subject/${type}/${id}`;
}
